import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=5377b03f&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5377b03f')) {
      api.createRecord('5377b03f', component.options)
    } else {
      api.reload('5377b03f', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=5377b03f&", function () {
      api.rerender('5377b03f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8skhky5Bv0sMw/JS/pricehelp.vue"
export default component.exports